import Intl from 'intl';
import { currentLocale } from '@trello/locale';
import { forTemplate } from 'app/common/lib/util/i18n';

const formatCC = forTemplate('credit_card');

let formatter: Intl.NumberFormat | null = null;

export const formatMoney = (num: number, normalRounding?: boolean) => {
  if (formatter === null) {
    formatter = new Intl.NumberFormat(currentLocale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  if (normalRounding) {
    return formatter.format(num);
  } else {
    // Trello displays prices like 9.999 as $9.99
    return formatter.format(Math.floor(num * 100) / 100);
  }
};

/**
 * Returns localized currency string
 * @param num: number
 * @param normalRounding?: boolean
 */
export const formatMoneyLocalized = (num: number, normalRounding?: boolean) =>
  formatCC('amount-usd', {
    amount: formatMoney(num, normalRounding),
  });
